import React from "react";
import "../styles/ProgressBar.css";

const ProgressBar = ({ currentStage, shouldShowSuperannuation = true }) => {
  const stages = shouldShowSuperannuation
    ? ["Personal Info", "Financial Info", "Superannuation Info", "Professional Info", "User Settings"]
    : ["Personal Info", "Financial Info", "Professional Info", "User Settings"];

  return (
    <div className="progress-container">
      <div className="progress-circles">
        {stages.map((stage, index) => (
          <div key={index} className="progress-step">
            <div className={`circle ${currentStage >= index ? "active" : ""}`}>
              {index + 1}
            </div>
            {index !== stages.length - 1 && (
              <div
                className={`line ${currentStage > index ? "active" : ""}`}
              ></div>
            )}
          </div>
        ))}
      </div>
      <div className="progress-labels">
        {stages.map((stage, index) => (
          <div
            key={index}
            className={`label ${currentStage >= index ? "active" : ""}`}
          >
            {stage}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
